import { CSSProperties, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PocheProps {
  // Art-direction note shown as a figure caption until a real photo is supplied.
  caption?: string;
  src?: string;
  alt?: string;
  ratio?: string;
  // object-position for the photo, e.g. '50% 20%' to keep a tower's crown in a tighter crop.
  focus?: string;
  // Above-the-fold images (the hero) load eagerly; everything else is lazy.
  eager?: boolean;
  tone?: 'day' | 'dusk';
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

// Image placeholder drawn as architectural poché (hatched section fill). Pass `src` to swap in
// the real photograph; the hatch then sits behind it as a loading surface.
export default function Poche({ caption, src, alt = '', ratio, focus, eager, tone = 'day', className, style, children }: PocheProps) {
  return (
    <div
      className={cn('poche', tone === 'dusk' && 'poche--dusk', className)}
      style={{ ...(ratio ? { aspectRatio: ratio } : null), ...style }}
    >
      {src && <img src={src} alt={alt} loading={eager ? 'eager' : 'lazy'} style={focus ? { objectPosition: focus } : undefined} />}
      {children}
      {caption && !src && <span className="poche__cap mono">{caption}</span>}
    </div>
  );
}
